import { useMemo } from 'react';
import { SelectOption } from '@/components/form/select';

export const useSelectOptions = <
  TValue extends string | number,
  T extends Record<TLabelKey, string> & Record<TValueKey, TValue>,
  TLabelKey extends keyof T,
  TValueKey extends keyof T,
>(
  items: T[],
  labelKey: TLabelKey,
  valueKey: TValueKey,
) =>
  useMemo<SelectOption<TValue>[]>(
    () =>
      items.map((item) => ({ label: item[labelKey], value: item[valueKey] })),
    [items, labelKey, valueKey],
  );

export const useSelectOptionsFromArray = <TValue extends string | number>(
  items?: TValue[],
) =>
  useMemo<SelectOption<TValue>[]>(
    () =>
      (items ?? []).map((item) => ({
        label: typeof item === 'string' ? item : item.toString(),
        value: item,
      })),
    [items],
  );
